module.exports = __webpack_public_path__ + "static/media/Picture4-453x300x150.d2affbcb.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagenes/Picture4-453x300x150.png
// module id = 109
// module chunks = 0